import { EApertureIndex } from "./EApertureIndex";
import { EBoneType } from "./EBoneType";

export class ApplianceApertureIdentifier {
    public boneType: EBoneType;
    public index: EApertureIndex;

    constructor(boneType: EBoneType, index: EApertureIndex) {
        this.boneType = boneType;
        this.index = index;
    }

    equals(obj: any): boolean {
        return obj instanceof ApplianceApertureIdentifier &&
               this.boneType === obj.boneType &&
               this.index === obj.index;
    }

    static get OvenBottom(): ApplianceApertureIdentifier {
        return new ApplianceApertureIdentifier(EBoneType.Oven, EApertureIndex.Bottom);
    }

    static get OvenTop(): ApplianceApertureIdentifier {
        return new ApplianceApertureIdentifier(EBoneType.Oven, EApertureIndex.Top);
    }
}